import { Reducer } from 'react';
import { handleReducer } from './index';
import { IContent, IContentDetail, IContentState } from 'src/interface';
import { LocalStore, Logger } from 'src/utils';
import { LSTORAGE_KEY } from 'src/constants';
import Emitter from 'src/utils/emitter';
import { ACTIONS } from '../actions/content/dispatchActions';

const defaultFStorage: IContentState | null =
    LocalStore.get(LSTORAGE_KEY.REDUX_CONTENT) ||
    ({
        largeFont: false,
    } as IContentState);

const STATE_DEFAULT = Object.assign({}, defaultFStorage, {
    isOpen: false,
    contentCurrentId: -1,
    contents: {},
    isFetching: false,
    readIds: [],
});

const handler = {
    [ACTIONS.TOGGLE_FONT_SIZE]: (state: IContentState): IContentState => {
        LocalStore.set(LSTORAGE_KEY.REDUX_CONTENT, {
            largeFont: !state.largeFont,
        });

        return {
            ...state,
            largeFont: !state.largeFont,
        };
    },
    [ACTIONS.PUT_CONTENT]: (
        state: IContentState,
        content: IContentDetail,
    ): IContentState => {
        if (!content) {
            return { ...state };
        }

        const contents = Object.assign({}, state.contents);
        contents[content.contentId] = content;

        return {
            ...state,
            isFetching: false,
            contents,
        };
    },
    [ACTIONS.OPEN_CONTENT]: (
        state: IContentState,
        content: IContent,
    ): IContentState => {
        const contents = Object.assign({}, state.contents);
        contents[content.contentId] = content as IContentDetail;

        return {
            ...state,
            isOpen: true,
            isFetching: true,
            contentCurrentId: content.contentId,
            contents,
        };
    },
    [ACTIONS.CLOSE_CONTENT]: (state: IContentState): IContentState => {
        return {
            ...state,
            isOpen: false,
            isFetching: false,
            contentCurrentId: -1,
        };
    },
    [ACTIONS.IS_OPEN_UPDATE]: (
        state: IContentState,
        isOpen: boolean | undefined,
    ): IContentState => {
        return {
            ...state,
            isOpen: isOpen === undefined ? !state.isOpen : isOpen,
        };
    },
    [ACTIONS.SET_READ_ID]: (
        state: IContentState,
        id: number,
    ): IContentState => {
        if ((window as any)._BM?.contentIdsExclude?.indexOf(id) < 0) {
            (window as any)._BM?.contentIdsExclude?.push(id);
        }

        const _readIds =
            state.readIds.indexOf(id) > -1
                ? [...state.readIds]
                : [...state.readIds, id];

        const mostReadId = _readIds.slice(-5);
        (window as any)._BM.mostReadId = mostReadId;
        (window as any)._BM.contentReadIds = _readIds;

        Logger.debug('_readIds:', _readIds.length);

        Emitter.emit('readContentIdChange', {
            currentId: id,
            mostReadId: mostReadId,
        });

        return {
            ...state,
            readIds: _readIds,
        };
    },
};

const adReducer: Reducer<any, any> = (state = STATE_DEFAULT, action: any) => {
    return handleReducer(handler, state, action);
};

export default adReducer;
